module.exports = __webpack_public_path__ + "static/media/pla_cem_mix.064a0d18.png";